module.exports = __webpack_public_path__ + "img/support.b01b6f01.svg";